/* eslint class-methods-use-this: "off" */
import { isEditableGridModel } from "../EditableGridModel.js";
import GridMouseHandler from "../GridMouseHandler.js";
import GridRange from "../GridRange.js";
/**
 * Handles clicking on a cell to edit it in an editable grid
 */
class EditMouseHandler extends GridMouseHandler {
  onDoubleClick(_ref, grid) {
    var column = _ref.column,
      row = _ref.row;
    var model = grid.props.model;
    if (isEditableGridModel(model) && column != null && row != null && model.isEditableRange(GridRange.makeCell(column, row))) {
      grid.startEditing(column, row);
      return true;
    }
    return false;
  }
}
export default EditMouseHandler;
//# sourceMappingURL=EditMouseHandler.js.map